/* eslint-disable @typescript-eslint/no-floating-promises */
/* istanbul ignore file */

import React from "react"
import {hydrateRoot} from "react-dom/client"
import {Provider} from "react-redux"
import {CacheProvider} from "@emotion/react"
import {createEmotionCache} from "@next/emotion-cache"

import App from "../App"
import {getNextItemNumber, getProps, getState, getStore} from "./utils"
import "./polyfill"

window.addEventListener("hydrate-chunks-product-summary", hydrateAvailableItems)

function hydrateAvailableItems() {
    let itemNumber = getNextItemNumber()

    while (itemNumber) {
        ;(no => {
            setTimeout(() => {
                const appProps = getProps(no)
                const state = getState(no)
                const store = getStore(no, {...state})
                const emotionCache = createEmotionCache({
                    key: "produc",
                    rtl: appProps.textAlignment === "rtl",
                })
                hydrateClientApp({itemNumber: no, state, appProps, store, emotionCache})
            }, 0)
        })(itemNumber)
        itemNumber = getNextItemNumber()
    }
}

interface HydrateClientAppArgs {
    itemNumber: string
    state
    appProps: any
    store
    emotionCache
}

function hydrateClientApp({itemNumber, appProps, store, state, emotionCache}: HydrateClientAppArgs) {
    const props = {...appProps, itemNumber}
    const containers = document.querySelectorAll(`#next-product-summary-entrypoint-${itemNumber}`)
    if (!containers) return
    containers.forEach(el => {
        const container = el as HTMLElement
        runHydration({store, props, state, container, emotionCache})
    })
}

function runHydration({store, props, state, container, emotionCache}) {
    if (container.dataset.hydrateCompleted) return

    hydrateRoot(
        container,
        <Provider store={store} serverState={state}>
            <CacheProvider value={emotionCache}>
                <App {...props} />
            </CacheProvider>
        </Provider>,
    )
    // eslint-disable-next-line no-param-reassign
    container.dataset.hydrateCompleted = "true"
}
